/**
 * <s-bundle-offer> — adds the tee (chosen size) and the beanie to the cart as two separate lines
 * in one request, closes the pop-up, then opens the cart drawer. The saving itself comes from the
 * store's automatic bundle discount.
 */
class SBundleOffer extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('[data-bundle-form]');
    this.submitButton = this.querySelector('[data-bundle-submit]');
    this.errorEl = this.querySelector('[data-bundle-error]');
    this.sizeHint = this.querySelector('[data-bundle-size-hint]');
    this.form?.addEventListener('submit', this.#onSubmit);
    this.form?.addEventListener('change', this.#hideSizeHint);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.#onSubmit);
    this.form?.removeEventListener('change', this.#hideSizeHint);
  }

  #hideSizeHint = () => {
    if (this.sizeHint) this.sizeHint.hidden = true;
  };

  #onSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(this.form);
    const tee = String(data.get('tee') || '').trim();
    const beanie = String(data.get('beanie') || '').trim();
    if (!tee || !beanie) {
      if (this.sizeHint) this.sizeHint.hidden = false;
      this.querySelector('[data-bundle-sizes] input:not(:disabled)')?.focus();
      return;
    }

    this.#showError('');
    this.submitButton.disabled = true;
    try {
      const result = await window.Shopify.actions.updateCart(
        {
          lines: [
            { merchandiseId: tee, quantity: 1 },
            { merchandiseId: beanie, quantity: 1 },
          ],
        },
        { event: { context: 'product', detail: { source: 's-bundle-offer' } } }
      );
      const userError = result?.userErrors?.[0]?.message;
      if (userError) {
        this.#showError(userError);
      } else {
        this.closest('dialog')?.close();
        await window.Shopify.actions.openCart?.();
      }
    } catch (error) {
      this.#showError(error?.message || this.dataset.errorMessage || '');
    } finally {
      this.submitButton.disabled = false;
    }
  };

  #showError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.hidden = !message;
  }
}

if (!customElements.get('s-bundle-offer')) customElements.define('s-bundle-offer', SBundleOffer);
